import React from 'react'
 import "./MasterApartmentsPage.scss"

import { useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import ComponentTabs from '../../../components/tabcomponent/TabComponent';
import DashboardHeader from '../../../components/dashboardheader/DashboardHeader';
// import CancelButton from '../../../components/buttons/cautton/CancelButton';
import ApartmentImport from './ApartmentImport';
import CancelButton from '../../../components/buttons/cancelbutton/CancelButton';

function ApartmentsPage() {

  // this is the admin data page that is showing 3 tabs
  // image, paste, saved data

  const [activeTab, setActiveTab] = useState(0);
  const {toggleMenu} = useOutletContext(); // get the toggleMenu function




  const tabItems = [
    {
    label: 'Paste',
    content: (
        <ApartmentImport/>
    )
  },
// {
//   label: 'List',
//   content: () => (
//     // <BuilderDataEdit
//     //   selectedTranstype={selectedTranstype}
//     //   // setSelectedTranstype={setSelectedTranstype}
//     //   selectedProptype={selectedProptype}
//     //   // setSelectedProptype={setSelectedProptype}
//     //   selectedColony={selectedColony}
//     //   // setSelectedColony={setSelectedColony}
//     //   isActive={activeTab === 2}
//     // />
//   )
// }
 
  ]
  
  ;
 
    return (
      <>
        <div className="apartmentPage">
          <div className="PageHeader">
            {/* Admin Data Test Page */}
            <DashboardHeader
              title="Apartments "
              toggleMenu={toggleMenu}
              variant="admin"
            ></DashboardHeader>
            {/* <h1 className="formTitle">Admin Data Test Page</h1>           */}
          </div>
          <div className="tabContainer">
            {/* <h1>Load Image, Crop, Copy, Paste and Save to Database</h1> */}

            <ComponentTabs
              tabs={tabItems}
              activeTab={activeTab}
              setActiveTab={setActiveTab}
            />

          
          </div>



        </div>
      </>
    );
}

export default ApartmentsPage